export default __webpack_public_path__ + "static/media/searchbox.1cc9353a.svg";